import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {},
    page: 1,
};

const filterSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setTempFilter: (state, action) => {
            const { componentId, key, value } = action.payload;
            if (!state.filters[componentId]) {
                state.filters[componentId] = {
                    tempFilters: {},
                    appliedFilters: {},
                    tempSearch: "",
                    search: null
                };
            }
            state.filters[componentId].tempFilters[key] = value;
        },
        applyFilters: (state, action) => {
            const { componentId } = action.payload;
            const current = state.filters[componentId];
            if (current) {
                current.appliedFilters = { ...current.tempFilters };
                current.search = current.tempSearch;
            }
            state.page = 1;
        },
        clearFilters: (state, action) => {
            const { componentId } = action.payload;
            if (state.filters[componentId]) {
                state.filters[componentId].appliedFilters = {};
                state.filters[componentId].tempFilters = {};
                state.filters[componentId].search = null;
                state.filters[componentId].tempSearch = "";
            }
            state.page = 1;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
        setSearch: (state, action) => {
            const { componentId, value } = action.payload;
            if (!state.filters[componentId]) {
                state.filters[componentId] = {
                    tempFilters: {},
                    appliedFilters: {},
                    tempSearch: "",
                    search: null
                };
            }
            state.filters[componentId].search = value;
            state.page = 1;
        },
        setTempSearch: (state, action) => {
            const { componentId, value } = action.payload;
            if (!state.filters[componentId]) {
                state.filters[componentId] = {
                    tempFilters: {},
                    appliedFilters: {},
                    tempSearch: "",
                    search: null
                };
            }
            state.filters[componentId].tempSearch = value;
        },
        clearSearch: (state, action) => {
            const { componentId } = action.payload;
            if (state.filters[componentId]) {
                state.filters[componentId].search = null;
                state.filters[componentId].tempSearch = "";
            }
        }
    }
});

export const {setTempFilter, applyFilters, clearFilters, setPage, clearSearch, setTempSearch, setSearch, setClear} = filterSlice.actions;
export default filterSlice.reducer;